module.exports = __webpack_public_path__ + "img/logo.3c3b7a02.png";